module.exports = __webpack_public_path__ + "img/module-info-special.3d31590a.jpg";